import { LayerListProviderService } from 'src/app/services/layer-list-provider.service';
import { SubScriptionMgr } from 'src/app/model/SubscriptionMgr';
import { SLLayer } from 'src/app/model/sl-layer';
import { AnyHandler } from 'src/app/types/@types/sl-v-types';
import { SLMap } from 'src/app/model/sl-map';
import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter, Input, OnDestroy, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { AccessLevels } from 'src/app/types/access-levels';
@Component({
	selector: 'app-snap-layer-select',
	templateUrl: './snap-layer-select.component.html',
	styleUrls: ['./snap-layer-select.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class SnapLayerSelectComponent implements OnInit, OnDestroy {

	@Input() minAccessLevel = AccessLevels.READ;
	@Output() layerChange = new EventEmitter<SLLayer>();
	@ViewChild('layerSelect', { static: true }) layerSelect: ElementRef<HTMLSelectElement>;
	private _snapLayer = '';;
	@Input()
	set snapLayer(layerId) {
		if (this._snapLayer === layerId) {
			return;
		}
		this._snapLayer = layerId;
		if (layerId !== '') {
			this.layerChange.emit(this.map.GetLayerById(layerId));
		} else {
			this.layerChange.emit(null);
		}
	}
	get snapLayer(): string {
		return this._snapLayer;
	}
	@Input() readyHandler: AnyHandler;
	private _map: SLMap;
	@Input()
	set map(map: SLMap) {
		this.SetMap(map);
		// this.UpdateSelect();
	}
	get map(): SLMap {
		return this._map;
	}
	public layers: Array<SLLayer> = [];
	public buildingLayers = true;
	public waitingForLayers = false;
	private ready = false;
	private subscriptions = new SubScriptionMgr();
	constructor(private cdr: ChangeDetectorRef,private layersSvc:LayerListProviderService) { }

	SetMap(map) {
		if (this._map === map) {
			return;
		}
		if (!this.ready) {
			setTimeout(() => {
				this.SetMap(map);
			}, 20);
			return;
		}
		this._map = map;
    this.layers = this.layersSvc.GetEditableLayers(this.map.layers);

		this.subscriptions.Subscribe(this._map.layerChange, () => {
			this.UpdateSelect();
		});
		if (this.waitingForLayers === true) { return; }
		this.UpdateSelect();
	}


	ngOnInit() {
		this.ready = true;
		if (!!this.map) {
			this.UpdateSelect();
		}
	}

  SetLayers() {
    if(!this.map) {
      window.requestAnimationFrame(()=>{
        this.SetLayers();
      });
      return;
    }
    this.layers = this.layersSvc.GetEditableLayers(this.map.layers);

  }
  Reset() {
    this.layerSelect.nativeElement.selectedIndex = 0;
    this.SnapLayerChanged();

  }
	SetLayer(layer: SLLayer): boolean {
    let changed = false;
		if (!!this.layers) {
			if (this.snapLayer !== layer.id) {
				this.snapLayer = layer.id;
				changed = true;
			}
			// this.UpdateSelect();
			this.layerSelect.nativeElement.selectedIndex = this.layers.indexOf(layer) + 1;
			if (changed) {
				this.SnapLayerChanged();
			}
		}
		return changed;
	}
	UpdateSelect() {
		if (!this.map && !this.map.layers) {
			window.requestAnimationFrame(() => {
				this.waitingForLayers = true;
				this.UpdateSelect();
			});
			return;
		}
		this.waitingForLayers = false;

		// $(this.layerSelect.nativeElement).children().remove();
		this.layers = [];
		this.buildingLayers = true;
		this.cdr.detectChanges();
		const layerIds = [];
		let i = -1;
		let selectedIndex = 0;
		for (const layer of this.map.layers) {
			if (layer.type >= 9000) {
				continue;
			}
			if (layer.hasSubLayers === true) { continue; }
			if (layer.access < this.minAccessLevel) { continue; }
			if (['point', 'line', 'polygon'].indexOf(layer.geom) < 0) { continue; }
			i += 1;
			if (layerIds.indexOf(layer.id) === -1) {
				this.layers.push(layer);
				layerIds.push(layer.id);


				if (layer.id === this.snapLayer) {
					selectedIndex = i;
				}
			}

		}
		this.buildingLayers = false;
		this.cdr.detectChanges();
		if (this._snapLayer === '') {
			this.layerSelect.nativeElement.selectedIndex = 0;
			this.cdr.detectChanges();

		}
		this.SnapLayerChanged();



	}
	SnapLayerChanged() {
		if ((this.map !== null) && (this._snapLayer !== '')) {
			const layer: SLLayer = this.map.GetLayerById(this.snapLayer);
			this.map.SetSnapLayer(layer);
			this.layerChange.emit(layer);
		}
    if(!!this.map && (this._snapLayer === '')) {
      this.map.SetSnapLayer();
    }

	}
	ngOnDestroy() {
		this.subscriptions.CancelSubscriptions();
	}

}
